// defaultYazilim.js
const defaultYazilim = {
  pageContent: [
    {
      __component: "sections.hero",
      badge: "ISO 27001 Uyumlu Varlık Yönetimi",
      badge_en: "ISO 27001 Compliant Asset Management",
      title: "Yazılım ve Uygulama Yönetimi",
      title_en: "Software and Application Management",
      description:
        "ISO 27001 standartlarına tam uyumluluk için tüm yazılım varlıklarınızı, lisanslarınızı ve güvenlik yamalarınızı tek bir merkezi platformdan kontrol edin ve risklerinizi minimize edin.",
      description_en:
        "Minimize your risks by controlling all your software assets, licenses, and security patches from a single central platform for full compliance with ISO 27001 standards.",
    },
    {
      __component: "sections.stats-section",
      stats: [
        {
          icon: "inventory_2",
          iconColor: "blue",
          title: "Toplam Yazılım",
          title_en: "Total Software",
          value: "124",
          subText: "+5% bu ay",
          subText_en: "+5% this month",
        },
        {
          icon: "emergency",
          iconColor: "green",
          title: "Kritik Yamalar",
          title_en: "Critical Patches",
          value: "12",
          subText: "-2% geçen hafta",
          subText_en: "-2% last week",
        },
        {
          icon: "verified",
          iconColor: "orange",
          title: "Lisans Uyumluluğu",
          title_en: "License Compliance",
          value: "%98",
          subText: "Hedefin Üzerinde",
          subText_en: "Above the target",
        },
      ],
    },
    {
      __component: "sections.features-section",
      badge: "Özellikler",
      badge_en: "Features",
      Title: "Temel Özellikler",
      Title_en: "Key Features",
      description:
        "Yazılım ve işletim sistemlerinizi ISO 27001 A.8.19 (Yazılım kurulumu) ve A.8.32 (Teknik açık yönetimi) maddelerine uygun şekilde yönetin.",
      description_en:
        "Manage your software and operating systems in accordance with ISO 27001 A.8.19 (Software installation) and A.8.32 (Technical vulnerability management).",
      cards: [
        {
          icon: "lists",
          title: "Yazılım Envanteri",
          title_en: "Software Inventory",
          description:
            "Kurum genelindeki tüm uygulamaları, sürümleri ve işletim sistemlerini otomatik olarak tespit edin ve listeleyin.",
          description_en:
            "Automatically detect and list all applications, versions, and operating systems across the organization.",
        },
        {
          icon: "description",
          title: "Lisans Takibi",
          title_en: "License Tracking",
          description:
            "Yazılım lisans sürelerini, kullanım haklarını ve yenileme maliyetlerini merkezi bir panelden izleyin, süresi dolanları görün.",
          description_en:
            "Monitor software license periods, usage rights, and renewal costs from a central dashboard, and see which licenses have expired.",
        },
        {
          icon: "system_update",
          title: "Yama Yönetimi",
          title_en: "Patch Management",
          description:
            "Güvenlik açıklarını kapatmak için güncel yama durumlarını takip edin ve ISO 27001 gereği yama politikasını uygulayın.",
          description_en:
            "Monitor current patch statuses to close security vulnerabilities and implement the patching policy as required by ISO 27001.",
        },
        {
          icon: "security_update_warning",
          title: "Uygulama Güvenliği",
          title_en: "Application Security",
          description:
            "Kullanılan yazılımlardan kaynaklanan riskleri otomatik olarak analiz edin ve düzeltici faaliyetler planlayın.",
          description_en:
            "Automatically analyze risks arising from the software being used and plan corrective actions.",
        },
      ],
    },
    {
      __component: "sections.grid-section",
      title: "İşletim Sistemleri ve Uygulama Kontrolüo",
      title_en: "Operating Systems and Application Control",
      description:
        "RUZY, kuruluşunuzda yüklü olan her türlü yazılımın yetkilendirilmiş olduğundan emin olmanızı sağlar. Kara liste ve beyaz liste yönetimi ile güvenli olmayan yazılımların ağınıza girişini engelleyin.",
      description_en:
        "RUZY ensures that all software installed in your organization is authorized. Use blacklist and whitelist management to prevent unsafe software from entering your network.",
      features: [
        {
          icon: "check_circle",
          title: "Onaylanmamış yazılım kullanımı tespiti",
          title_en: "Detection of unauthorized software use.",
          description: "",
          description_en: "",
        },
        {
          icon: "check_circle",
          title: "İşletim sistemi sürüm sonu (EOL) takibi",
          title_en: "Operating system end-of-version (EOL) tracking",
          description: "",
          description_en: "",
        },
        {
          icon: "check_circle",
          title: "Shadow IT (Gölge IT) risk analizi",
          title_en: "Shadow IT risk analysis",
          description: "",
          description_en: "",
        },
      ],
    },
  ],
};

export default defaultYazilim;